module.exports = __webpack_public_path__ + "static/media/icon6.88282c2c.svg";